import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface CancelPickupDialogData {
  scheduleId: number;
  assetName: string;
  driverName: string;
}

@Component({
  selector: 'lohi-cancel-pickup-dialog',
  templateUrl: './cancel-pickup-dialog.component.html',
  styleUrls: ['./cancel-pickup-dialog.component.scss'],
})
export class CancelPickupDialogComponent {
  public reason = '';

  constructor(
    public dialogRef: MatDialogRef<CancelPickupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelPickupDialogData,
  ) {}

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onConfirm(): void {
    this.dialogRef.close({
      scheduleId: this.data.scheduleId,
      reason: this.reason,
    });
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
